import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CAvatar,
  CBadge,
  CContainer,
  CButton,
} from "@coreui/react";
import { useNavigate } from "react-router-dom";
import dummyAvatar from "../../assets/avatar.png";
import SellerAddressSection from "../../components/seller/SellerAddressSection";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMyTradePreference,
  fetchUserAddresses,
  fetchUserProfile,
} from "../../features/user/userSlice";
import { capitalizeFirst } from "../../utils/stringUtils";
import AppLoader from "../../components/seller/AppLoader";
import {
  fetchAccountStatus,
  fetchPaymentMethods,
} from "../../features/seller/sellerSlice";
import AppToast from "../../components/seller/AppToast";

const SellerProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    profile,
    addresses,
    profileLoading,
    addressLoading,
    myPreference = [],
  } = useSelector((state) => state.user);
  const { data, loading, error } = useSelector(
    (state) => state.seller.accountStatus,
  );
  // const {
  //   data: paymentData,
  //   loading: paymentLoading,
  //   error: paymentError,
  // } = useSelector((state) => state.seller.paymentMethods);
  // const { stripeConnecting } = useSelector((state) => state.seller);
  // console.log("paymentData:", paymentData);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("info");
  const [toastMessage, setToastMessage] = useState("");
  const [connecting, setConnecting] = useState(false);
  console.log("Profile data in Sellerprofile:", profile);
  console.log("Pref data in Sellerprofile:", myPreference);
  console.log("Account Status:", data);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchUserProfile()).unwrap();
        await dispatch(fetchUserAddresses()).unwrap();
        await dispatch(fetchMyTradePreference()).unwrap().catch(console.error);
        await dispatch(fetchAccountStatus()).unwrap();
      } catch (err) {
        console.error("Error fetching profile or addresses:", err);
        // Optional: show a toast or update error state
      }
    };

    fetchData();
  }, [dispatch]);

  // console.log("Avatar:", profile?.profile_image_url);
  // console.log("Name:", profile?.name);
  const [avatarSrc, setAvatarSrc] = useState(dummyAvatar);

  useEffect(() => {
    if (profile?.profile_image_url) {
      // Add cache-busting parameter to prevent browser caching issues
      const timestamp = new Date().getTime();
      const imageUrl = profile.profile_image_url.includes("?")
        ? `${profile.profile_image_url}&t=${timestamp}`
        : `${profile.profile_image_url}?t=${timestamp}`;
      setAvatarSrc(imageUrl);
    } else {
      setAvatarSrc(dummyAvatar);
    }
  }, [profile]);

  if (profileLoading || addressLoading || !profile) {
    return <AppLoader />;
  }

  const handleConnectToStripe = async () => {
    // 🚀 MANDATORY ADDRESS CHECK: User must have at least one address before onboarding
    if (!addresses || addresses.length === 0) {
      setToastType("warning");
      setToastMessage("Please add your business address below before connecting to Stripe.");
      setToastVisible(true);
      return;
    }

    try {
      setConnecting(true);
      const response = await dispatch(fetchPaymentMethods()).unwrap();
      const url = response?.stripe_onboarding_url;

      if (url) {
        window.location.href = url;
      } else {
        setToastType("warning");
        setToastMessage("Stripe onboarding URL not available.");
        setToastVisible(true);
      }
    } catch (error) {
      console.error("Failed to fetch Stripe onboarding URL:", error);
      setToastType("danger");
      setToastMessage("Error connecting to Stripe.");
      setToastVisible(true);
    } finally {
      setConnecting(false);
    }
  };

  const isStripeConnected =
    profile?.stripe_account_id &&
    data?.charges_enabled &&
    data?.payouts_enabled &&
    data?.details_submitted;

  return (
    <>
      <CContainer fluid className="px-3 mt-4">
        <CCol xs={12} className="mb-4">
          <CCard className="shadow-sm border-0 rounded-4">
            <CCardBody>
              <CRow>
                {/* Left Section */}
                <CCol
                  md={4}
                  className="text-center border-end d-flex flex-column align-items-center justify-content-center p-4 bg-light rounded-start"
                >
                  <CAvatar
                    src={avatarSrc}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: "50%", // <-- force circle
                      overflow: "hidden", // <-- hide overflow
                      display: "inline-block", // <-- prevent stretching
                    }}
                    className="mb-3 border"
                    onError={() => setAvatarSrc(dummyAvatar)}
                  />
                  <h4 className="fw-bold mb-2">{profile.name}</h4>
                  <CBadge
                    color={
                      profile.kyc_status === "approved" ? "success" : "warning"
                    }
                    className="px-4 py-2 rounded-pill fs-6"
                  >
                    {capitalizeFirst(
                      profile.kyc_status === "approved"
                        ? "verified"
                        : "not_submitted",
                    )}
                  </CBadge>
                </CCol>

                {/* Right Section */}
                <CCol md={8} className="p-4">
                  <h4 className="mb-4 text-primary">Profile Information</h4>

                  {[
                    { label: "Email", value: profile.email },
                    { label: "Role", value: profile.role },
                    { label: "Phone", value: profile.phone },
                    { label: "Company Name", value: profile.company_name },
                    {
                      label: "Trade Preferences",
                      value: (
                        <div className="d-flex flex-wrap gap-2">
                          {myPreference?.length > 0 ? (
                            myPreference.map((pref, i) => (
                              <CBadge
                                key={i}
                                color="info"
                                className="px-3 py-2 rounded-pill"
                              >
                                {pref.name}
                              </CBadge>
                            ))
                          ) : (
                            <span className="text-muted">
                              No preferences set
                            </span>
                          )}
                        </div>
                      ),
                    },
                  ].map((item, index) => (
                    <CRow
                      className="align-items-center py-3 mb-2 border-bottom"
                      key={index}
                    >
                      <CCol md={4} className="text-muted fs-6 fw-semibold">
                        {item.label}
                      </CCol>
                      <CCol md={8} className="fs-5 text-dark">
                        {item.value}
                      </CCol>
                    </CRow>
                  ))}
                  <div className="text-end mb-3">
                    <CButton
                      color="primary"
                      size="sm"
                      className="me-2"
                      onClick={() => navigate("/seller/edit-profile")}
                    >
                      Edit Profile
                    </CButton>
                    <CButton
                      color="warning"
                      size="sm"
                      onClick={() => navigate("/seller/change-password")}
                    >
                      Change Password
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          {/* Connect to Stripe Section (Commented out - centralized in VerificationList)
          <CCard className="shadow-sm border-0 rounded-4 mt-4">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-1">Stripe Connect</h5>
                <p className="text-muted mb-0">
                  To receive payments, please connect your Stripe account.
                </p>
              </div>
              {isStripeConnected ? (
                <span className="fw-semibold text-success">Connected</span>
              ) : (
                <CButton
                  color="primary"
                  className="px-4 py-2"
                  onClick={handleConnectToStripe}
                  disabled={connecting}
                >
                  {connecting ? "Connecting..." : "Connect to Stripe"}
                </CButton>
              )}
            </CCardBody>
          </CCard> */ }

          <SellerAddressSection addresses={addresses} />
        </CCol>
      </CContainer>
      <AppToast
        visible={toastVisible}
        setVisible={setToastVisible}
        type={toastType}
        message={toastMessage}
      />
    </>
  );
};

export default SellerProfile;
